const pageSize = 30;

export { pageSize };
